import { SelectBox } from './SelectBox';
import { Dropdown } from './components/dropdown/Dropdown';
export { SelectBox };
export var UInput = {
    Select: SelectBox,
    Dropdown: Dropdown
};
//# sourceMappingURL=index.js.mapimport { SelectBox } from './SelectBox';
import { Dropdown } from './components/dropdown/Dropdown';
export { SelectBox };
export var UInput = {
    Select: SelectBox,
    Dropdown: Dropdown
};
//# sourceMappingURL=index.js.map